import { mutationTree, actionTree } from 'typed-vuex'
import { getSappTrackingData, trackScholarship } from '~/lib/utils/utils'
import { SAPPTrackingEvent } from '~/types/sapp-track'

export const state = () => ({
  track: {
    impressions: []
  }
})

export const mutations = mutationTree(
  state,
  {
    addTrackedImpressions(state, { ids }) {
      state.track.impressions = state.track.impressions.concat(ids)
    }
  }
)

export const actions = actionTree(
  { state, mutations },
  {
    statScholarshipVisit(_, { sid }) {
      const data: SAPPTrackingEvent = getSappTrackingData('visit', sid, this.$auth.user.id)
      trackScholarship(data)
    },
    statGoalScholarshipClick(_, { sid }) {
      const data: SAPPTrackingEvent = getSappTrackingData('goal-click', sid, this.$auth.user.id)
      trackScholarship(data)
    },
    statSavedScholarship(_, { sid }) {
      const data: SAPPTrackingEvent = getSappTrackingData('saved', sid, this.$auth.user.id)
      trackScholarship(data)
    },
    statIgnoredScholarship(_, { sid }) {
      const data: SAPPTrackingEvent = getSappTrackingData('ignored', sid, this.$auth.user.id)
      trackScholarship(data)
    },
    statStartedScholarship(_, { sid }) {
      const data: SAPPTrackingEvent = getSappTrackingData('started', sid, this.$auth.user.id)
      trackScholarship(data)
    },
    statScholarshipImpression({ state, commit }, { ids, bufferData, cb }) {
      const notTrackedIds = ids.filter(id => !state.track.impressions.includes(id))
      if (notTrackedIds.length) {
        commit('addTrackedImpressions', { ids: notTrackedIds })
        const externalScholarshipIds = bufferData.filter(item => notTrackedIds.includes(item.id) && item.externalScholarshipId).map(item => item.externalScholarshipId)
        if (cb) { cb(notTrackedIds) }
        externalScholarshipIds.forEach((sid) => {
          const data: SAPPTrackingEvent = getSappTrackingData('impression', sid, this.$auth.user.id)
          trackScholarship(data)
        })
      }
    }
  }
)
